

















































































































































































































































































































































































import axios from 'axios';
import { format } from 'date-fns';
import { Component, Vue } from 'vue-property-decorator';

import DataApiManager from '@/api/dataCoreApiManager';
import { BaseVue } from '@/BaseVue';
import UiButton from '@/components/ui/UiButton.vue';
import UiLoading from '@/components/ui/UiLoading.vue';
import UiPageHeader from '@/components/ui/UiPageHeader.vue';

import { baConfig } from '../../../config';
import {
  DataCoreSvcFeedrunhdlGetFeedRunDataOutput,
  DataCoreSvcFeedrunhdlGetTablesOutput,
  DataCoreSvcFeedrunsFeedRunAggregate,
  FeedRunApi,
} from '../../../generated/data-core-svc';

@Component({
  components: {
    UiButton,
    UiLoading,
    UiPageHeader,
  },
})
export default class FeedRunDetail extends BaseVue {
  public feedRun: DataCoreSvcFeedrunsFeedRunAggregate | null = null;
  public feedRunTables: DataCoreSvcFeedrunhdlGetTablesOutput | null = null;
  public isLoading = false;
  public error: string | null = null;
  public isDownloading = false;
  public isLoadingErrors = false;
  public feedRunErrors: any[] = [];
  public feedRunErrorMessage: string | null = null;
  public showDownloadDropdown = false;

  /**
   * Toggle the download dropdown menu
   */
  toggleDownloadDropdown(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.showDownloadDropdown = !this.showDownloadDropdown;
  }

  /**
   * Handle clicks outside of the dropdown to close it
   */
  handleClickOutside(event: MouseEvent): void {
    const dropdown = this.$el.querySelector('.tw-relative.tw-inline-block.tw-text-left');
    if (dropdown && !dropdown.contains(event.target as Node) && this.showDownloadDropdown) {
      this.showDownloadDropdown = false;
    }
  }

  /**
   * Custom download file method that handles downloading from a URL
   * @param url The URL to download from
   * @param filename The filename to save as
   */
  async customDownloadFile(url: string, filename: string): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        console.log('Downloading from URL:', url);

        const xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';

        // Add CORS headers
        xhr.setRequestHeader('Access-Control-Allow-Methods', 'GET');
        xhr.setRequestHeader('Access-Control-Allow-Origin', '*');

        // Track download progress
        xhr.onprogress = (e) => {
          if (e.lengthComputable) {
            const percentComplete = Math.round((e.loaded / e.total) * 100);
            console.log(`Download progress: ${percentComplete}%`);
          }
        };

        xhr.onload = () => {
          console.log('Download response:', {
            status: xhr.status,
            statusText: xhr.statusText,
          });

          if (xhr.status >= 200 && xhr.status < 300) {
            const blob = xhr.response;
            const respUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = respUrl;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            // Clean up and remove the link
            link.parentNode?.removeChild(link);
            resolve();
          } else {
            const error = new Error(`Download failed: ${xhr.status} ${xhr.statusText}`);
            console.error('Download error details:', error);
            reject(error);
          }
        };

        xhr.onerror = () => {
          console.error('XHR Error:', xhr.statusText);
          reject(new Error('Network error during download'));
        };

        xhr.send();
      } catch (err) {
        console.error('Download setup failed:', err);
        reject(err);
      }
    });
  }

  get feedId(): string {
    return this.$route.params.feedId;
  }

  get feedRunId(): string {
    return this.$route.params.runId;
  }

  // Override the BaseVue orgId getter to ensure it's properly accessed
  get orgId(): string {
    return this.$store.state.currentOrg?.id;
  }

  async mounted() {
    await this.loadFeedRunDetails();
  }

  async created() {
    await this.loadFeedRunDetails();

    // Add click outside listener for dropdown
    document.addEventListener('click', this.handleClickOutside);
  }

  beforeDestroy() {
    // Remove click outside listener
    document.removeEventListener('click', this.handleClickOutside);
  }

  goBackToFeed() {
    this.$router.push({ name: 'FeedDetailV2', params: { id: this.feedId } });
  }

  get useDataCoreV2() {
    return (
      this.checkFeatureFlag('import-v3', this.$store.getters.features) ||
      this.checkFeatureFlag('data-core-v2', this.$store.getters.features)
    );
  }

  /**
   * Load feed run tables for a specific feed run ID
   */
  async loadFeedRunTables() {
    this.isLoading = true;
    try {
      const feedRunApi = DataApiManager.getFeedRunApi();

      const resp = await feedRunApi.getTables(this.orgId, this.feedId, this.feedRunId, {
        withCredentials: true,
      });

      if (resp.status === 200) {
        this.feedRunTables = resp.data;
        console.log('Feed run tables data:', this.feedRunTables);
      } else {
        console.error(`Error loading feed run tables: ${resp.statusText || 'Unknown error'}`);
      }
    } catch (err) {
      console.error('Error loading feed run tables:', err);
    }
  }

  async loadFeedRunDetails() {
    this.isLoading = true;
    this.error = null;
    try {
      // Use the DataApiManager to get feed run data
      const api = DataApiManager.getInstance(true);

      // Get the feed run data directly from the list endpoint
      // Call API with correct parameter order based on TypeScript definition
      const resp = await api.handlersFeedrunhdlFeedRunHandlerListRuns(
        this.orgId,
        this.feedId,
        this.feedRunId, // filterFeedRunId - just pass the ID directly
        undefined, // filterArchived
        undefined, // filterPendingApproval
        undefined, // startedEarlierThanSEC
        undefined, // startedLaterThanSEC
        undefined, // pageToken
        1, // pageSize - we only need one run
        { withCredentials: true } // Request options
      );

      if (resp.status === 200 && resp.data.items && resp.data.items.length > 0) {
        // Use the first item from the response
        const data = resp.data.items[0];

        // Create a new object with our expected interface to avoid type errors
        const processedData = { ...data };

        // Handle status capitalization differences
        if (data.status && typeof data.status === 'string') {
          processedData.status = data.status.toUpperCase();
        }

        this.feedRun = processedData;
        console.log('Feed run data:', this.feedRun);

        // Load feed run tables data
        await this.loadFeedRunTables();
      } else {
        this.error = `Error loading feed run details: ${resp.statusText || 'Feed run not found'}`;
      }
    } catch (err) {
      console.error('Error loading feed run details:', err);
      this.error = `Error loading feed run details: ${(err as Error).message || 'Unknown error'}`;
    } finally {
      this.isLoading = false;
    }
  }

  formatDate(dateString: string | undefined): string {
    if (!dateString) return 'N/A';

    try {
      // Check if the date string already has timezone information
      const hasTimezone =
        dateString.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(dateString) || /[+-]\d{4}$/.test(dateString);

      // If no timezone info, assume UTC by appending 'Z'
      const normalizedDateString = hasTimezone ? dateString : `${dateString}Z`;

      // Parse the date string with proper timezone handling
      const date = new Date(normalizedDateString);

      // Use a more explicit date formatting approach
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const month = monthNames[date.getMonth()];
      const day = date.getDate().toString().padStart(2, '0');
      const year = date.getFullYear();

      // Format time with AM/PM
      let hours = date.getHours();
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours || 12; // the hour '0' should be '12'
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      const time = `${hours}:${minutes}:${seconds} ${ampm}`;

      // Return in a clear format that avoids misinterpretation
      return `${month} ${day}, ${year} at ${time}`;
    } catch (e) {
      console.error('Error formatting date:', e);
      return dateString;
    }
  }

  /**
   * Parse a Go-style duration string (e.g. "1h27m9.825216s") into milliseconds
   */
  parseDuration(durationStr: string): number {
    let totalMs = 0;

    // Regular expressions to extract different time components
    const hourMatch = durationStr.match(/([\d.]+)h/);
    const minuteMatch = durationStr.match(/([\d.]+)m/);
    const secondMatch = durationStr.match(/([\d.]+)s/);

    if (hourMatch && hourMatch[1]) {
      totalMs += parseFloat(hourMatch[1]) * 60 * 60 * 1000;
    }

    if (minuteMatch && minuteMatch[1]) {
      // If the minute part doesn't have a suffix, it might be part of the hour
      // Check if it's followed by 's' or is at the end of the string
      const minutePart = minuteMatch[0];
      const minuteIndex = durationStr.indexOf(minutePart);
      const nextChar = durationStr.charAt(minuteIndex + minutePart.length);

      if (nextChar === 's' || nextChar === '' || nextChar === '.') {
        // This is actually part of the hour, not a minute
        // Skip it as it's already counted in the hour part
      } else {
        totalMs += parseFloat(minuteMatch[1]) * 60 * 1000;
      }
    }

    if (secondMatch && secondMatch[1]) {
      totalMs += parseFloat(secondMatch[1]) * 1000;
    }

    return totalMs;
  }

  /**
   * Format a Go-style duration string into a human-readable format
   */
  formatDuration(durationStr: string): string {
    try {
      // For simple duration strings, just clean them up a bit
      return durationStr
        .replace(/\.\d+s/, 's') // Remove fractional seconds
        .replace(/h/, 'h ')
        .replace(/m/, 'm ')
        .replace(/s/, 's');
    } catch (e) {
      return durationStr;
    }
  }

  calculateDuration(startTime?: string, endTime?: string): string {
    // Access any duration data directly from the feedRun object if needed
    // For now, we'll just calculate it from the start and end times

    if (!startTime) return 'N/A';

    const start = new Date(startTime);
    // If no endTime is provided, use current time
    const end = endTime ? new Date(endTime) : new Date();

    try {
      // Calculate duration in milliseconds
      const durationMs = end.getTime() - start.getTime();

      // Convert to appropriate units
      const seconds = Math.floor(durationMs / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);

      if (days > 0) {
        return `${days} day${days > 1 ? 's' : ''} ${hours % 24} hr${hours % 24 !== 1 ? 's' : ''}`;
      } else if (hours > 0) {
        return `${hours} hr${hours !== 1 ? 's' : ''} ${minutes % 60} min${minutes % 60 !== 1 ? 's' : ''}`;
      } else if (minutes > 0) {
        return `${minutes} min${minutes !== 1 ? 's' : ''} ${seconds % 60} sec${seconds % 60 !== 1 ? 's' : ''}`;
      } else {
        return `${seconds} second${seconds !== 1 ? 's' : ''}`;
      }
    } catch (e) {
      return 'N/A';
    }
  }

  /**
   * Load feed run errors for a specific feed run ID
   */
  async loadFeedRunErrors() {
    this.isLoadingErrors = true;
    this.feedRunErrors = [];
    this.feedRunErrorMessage = null;
    try {
      // Use axios directly for the API call to ensure we get the raw response format
      const API3URL = baConfig.api3Url;
      const apiPath = `/v3/orgs/${this.orgId}/feeds/${this.feedId}/runs/${this.feedRunId}/data`;
      const fullUrl = new URL(apiPath, API3URL).toString();

      console.log('Loading feed run errors from URL:', fullUrl);

      // Use axios directly with the new filter option format
      const resp = await axios.get(fullUrl, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${this.$store.getters.accessToken || ''}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        params: {
          filterOption: 'unable_to_sync', // Use the new filter option for errors only
          limit: 100, // Limit to 100 errors
        },
      });

      console.log('Feed run errors response:', resp);

      if (resp.status === 200 && resp.data) {
        if (resp.data.rows && resp.data.rows.length > 0) {
          // Process the new error format
          const processedErrors = resp.data.rows.map((row: any) => ({
            entity_id: row.entity_id || 'Unknown ID',
            input: {
              // Include all input fields for reference
              ...row.input,
              timestamp: row.input?.timestamp || new Date().toISOString(),
              error: row.error || row.input?.error || 'Unknown error',
            },
            // Include resolved data if available
            resolved: row.resolved || {},
            // Extract error information
            error: row.error || row.input?.error || 'Validation error',
            warning: row.warning || row.input?.warning || '',
            is_synced: row.is_synced === false,
            // Add toggle properties for UI display
            _showInput: false,
            _showResolved: false,
          }));

          console.log('Processed errors:', processedErrors);

          this.feedRunErrors = processedErrors;
          this.$nextTick(() => {
            this.feedRunErrors = [...this.feedRunErrors];
            this.$forceUpdate();
          });
        } else {
          this.feedRunErrors = [];
          this.$toasted.info('No errors found for this feed run');
        }
      } else {
        this.feedRunErrorMessage = 'Error retrieving feed run data';
        this.$toasted.error(this.feedRunErrorMessage);
      }
    } catch (err) {
      this.feedRunErrorMessage = 'Error loading feed run errors';
      this.$toasted.error(this.feedRunErrorMessage);
      console.error('Error loading feed run errors:', err);
    } finally {
      this.isLoadingErrors = false;
    }
  }

  /**
   * Download feed run data for a specific feed run ID
   * @param filter Optional filter for the data (e.g., 'error', 'synced', 'unsynced')
   */
  async downloadFeedRunData(filter?: string) {
    this.isDownloading = true;
    this.showDownloadDropdown = false; // Close dropdown when download starts

    // Debug logging
    console.log('Download parameters:', {
      orgId: this.orgId,
      feedId: this.feedId,
      feedRun: this.feedRun,
      feedRunId: this.feedRunId,
    });

    try {
      // Check if we have the required parameters
      if (!this.orgId) {
        console.error('Missing orgId for download');
        throw new Error('Missing organization ID for download');
      }

      if (!this.feedId) {
        console.error('Missing feedId for download');
        throw new Error('Missing feed ID for download');
      }

      if (!this.feedRun) {
        console.error('Missing feedRun object for download');
        throw new Error('Missing feed run data for download');
      }

      // Use feedRunId from route params if feedRun.feedRunId is not available
      const runId = this.feedRun?.feedRunId || this.feedRunId;
      if (!runId) {
        console.error('Missing runId for download');
        throw new Error('Missing feed run ID for download');
      }

      console.log(`Downloading feed run data for ${runId} with filter: ${filter || 'all'}`);

      // Construct the base URL properly
      const API3URL = baConfig.api3Url;
      const apiPath = `/v3/orgs/${this.orgId}/feeds/${this.feedId}/runs/${runId}/data/download`;
      const fullUrl = new URL(apiPath, API3URL).toString();

      console.log('Download URL:', fullUrl);

      // Map the filter parameter to the correct backend filter option
      let filterOption = 'all_rows'; // Default to all rows
      if (filter === 'error') {
        filterOption = 'unable_to_sync';
      } else if (filter === 'unsynced') {
        filterOption = 'pending_and_unable_to_sync';
      }

      console.log(`Using filter option: ${filterOption}`);

      // Use axios to get the download link
      const resp = await axios.get(fullUrl, {
        withCredentials: true,
        params: {
          filterOption: filterOption,
          limit: 10000, // Set a high limit
        },
      });

      if (resp.status === 200) {
        if (resp.data && resp.data.link) {
          // Create a filename with the feed name and current date
          const now = new Date();
          const dateStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(
            now.getDate()
          ).padStart(2, '0')}`;
          const feedName = this.feedRun?.feedId || 'feed-run';
          const filename = `${feedName}-data-${dateStr}.csv`;

          console.log('Download link received:', resp.data.link);

          // Download the file from the provided link
          await this.customDownloadFile(resp.data.link, filename);

          this.error = ''; // Clear any previous errors
        } else {
          console.error('Response does not contain a download link:', resp.data);
          throw new Error('No download link received from server');
        }
      } else {
        throw new Error(`Failed to download feed run data: ${resp.statusText || 'Unknown error'}`);
      }
    } catch (err: any) {
      console.error('Error downloading feed run data:', err);

      // Default error message
      let errorMessage = 'Error downloading feed run data';

      // Simple error extraction with fallbacks
      if (err?.response?.data?.error && typeof err.response.data.error === 'string') {
        // Backend validation error
        console.log('API validation error:', err.response.data.error);
        errorMessage = err.response.data.error;
      } else if (err?.response?.data && typeof err.response.data === 'string') {
        // String error response
        errorMessage = err.response.data;
      } else if (err?.message && typeof err.message === 'string') {
        // Error object with message
        errorMessage = err.message;
      }

      this.error = errorMessage;
    } finally {
      this.isDownloading = false;
    }
  }

  calculateProcessingRate(feedRun: DataCoreSvcFeedrunsFeedRunAggregate): string {
    // Use syncedCount instead of syncedItems which was renamed in the API response
    if (!feedRun.startTime || (!feedRun.syncedCount && feedRun.syncedCount !== 0)) return '0';

    const start = new Date(feedRun.startTime);
    const end = feedRun.endTime ? new Date(feedRun.endTime) : new Date();

    // Calculate duration in minutes
    const durationMinutes = (end.getTime() - start.getTime()) / (1000 * 60);

    if (durationMinutes <= 0) return '0';

    // Calculate items per minute using syncedCount instead of syncedItems
    const rate = feedRun.syncedCount / durationMinutes;

    return rate.toFixed(2);
  }

  getCurrentStepIndex(): number {
    // Use type assertion to access properties not defined in the generated type
    const feedRunWithSteps = this.feedRun as unknown as {
      stepNames?: string[];
      currentStepName?: string;
    };

    if (!feedRunWithSteps || !feedRunWithSteps.stepNames || !feedRunWithSteps.currentStepName) return -1;
    return feedRunWithSteps.stepNames.indexOf(feedRunWithSteps.currentStepName);
  }

  /**
   * Check if a status indicates the feed run is completed
   */
  isCompleted(status: string | undefined): boolean {
    if (!status) return false;

    // Normalize status to uppercase for consistent comparison
    const normalizedStatus = status.toUpperCase();
    return ['COMPLETED', 'COMPLETE'].includes(normalizedStatus);
  }

  statusClass(status: string | undefined): Record<string, boolean> {
    if (!status) return { 'tw-text-gray-800': true };

    // Normalize status to uppercase for consistent comparison
    const normalizedStatus = status.toUpperCase();

    return {
      'tw-px-2 tw-inline-flex tw-text-xs tw-leading-5 tw-font-semibold tw-rounded-full': true,
      'tw-bg-green-100 tw-text-green-800': ['COMPLETED', 'COMPLETE'].includes(normalizedStatus),
      'tw-bg-yellow-100 tw-text-yellow-800': normalizedStatus === 'RUNNING',
      'tw-bg-red-100 tw-text-red-800': normalizedStatus === 'FAILED',
      'tw-bg-blue-100 tw-text-blue-800': normalizedStatus === 'PENDING',
      'tw-bg-gray-100 tw-text-gray-800': !['COMPLETED', 'COMPLETE', 'RUNNING', 'FAILED', 'PENDING'].includes(
        normalizedStatus
      ),
    };
  }
}
